import { Dropdown, type MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { APP_LANGUAGES, DEFAULT_LANGUAGE, type LanguageCode } from '@/shared/config/languages';
import { useAppStore } from '@/shared/lib/store/useAppStore';
import styles from './LanguageSwitcher.module.css';

interface LanguageSwitcherProps {
  variant?: 'light' | 'dark';
}

export const LanguageSwitcher = ({ variant = 'light' }: LanguageSwitcherProps) => {
  const { i18n, t } = useTranslation();
  const setLanguage = useAppStore((state) => state.setLanguage);

  const currentLanguage =
    APP_LANGUAGES.find((lang) => lang.code === i18n.language) ||
    APP_LANGUAGES.find((lang) => lang.code === DEFAULT_LANGUAGE)!;

  const handleLanguageChange = (langCode: LanguageCode) => {
    setLanguage(langCode);
    i18n.changeLanguage(langCode).then(() => {
      window.location.reload();
    });
  };

  const items: MenuProps['items'] = APP_LANGUAGES.map((lang) => ({
    key: lang.code,
    label: (
      <div className={styles.menuItem}>
        <lang.Flag className={styles.flagIcon} />
        <span className={styles.langName}>{lang.name}</span>
      </div>
    ),
    onClick: () => handleLanguageChange(lang.code as LanguageCode),
  }));

  return (
    <Dropdown menu={{ items, selectedKeys: [currentLanguage.code] }} trigger={['click']} placement='bottomRight'>
      <button type='button' className={`${styles.switcher} ${styles[variant]}`} aria-label={t('common.selectLanguage')}>
        <currentLanguage.Flag className={styles.flagIcon} />
      </button>
    </Dropdown>
  );
};
